module.exports = __webpack_public_path__ + "static/media/3.6f31f6c8.jpg";